export default class BaseComponent {
    render() {
        console.error('Method not implemented.');
    }
}


/** WEBPACK FOOTER **
 ** ./assets/scripts/src/basecomponent.js
 **/